import { jsx as _jsx } from "react/jsx-runtime";
import { ClockOutlinedIcon } from '@getgo/chameleon-icons/react';
import { Alert } from '@getgo/chameleon-web-react-wrapper';
import classNames from 'classnames';
import classes from './WebChatAfterHoursMessageEvent.module.scss';
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
const WebChatAfterHoursMessageEvent = ({ fullWidth, compact, event, color, }) => {
    console.warn('WebChatAfterHoursMessageEvent is deprecated, use @ucc-messaging/inbox-common-ui instead');
    let style = null;
    if (color) {
        style = {
            backgroundColor: 'var(--goto-ui-background)',
            borderColor: color,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            '--goto-icon-color': color,
        };
    }
    return (_jsx("div", Object.assign({ role: "listitem", className: classNames(classes.content, {
            [classes.fullWidth]: fullWidth,
            [classes.compact]: compact,
        }) }, { children: _jsx(Alert, Object.assign({ icon: _jsx(ClockOutlinedIcon, {}, void 0), variant: "info", style: style }, { children: event.afterHoursMessage }), void 0) }), void 0));
};
export default WebChatAfterHoursMessageEvent;
//# sourceMappingURL=WebChatAfterHoursMessageEvent.js.map